import { t } from 'i18next';
import { useCallback } from 'react';
import { useMutation } from 'react-query';

import { NotificationPosition } from 'core/enums';
import { useHandleErrors } from 'core/hooks';
import { fileService } from 'core/services';
import { IFileUploadRequestPayload } from 'core/types';

export const useFilesActions = ({
  position = NotificationPosition.DRAWER,
}: {
  position?: NotificationPosition;
} = {}) => ({
  ...useFileUpload({ position }),
});

const useFileUpload = ({ position }: { position?: NotificationPosition }) => {
  const { errors } = useHandleErrors({
    loading: { message: t('messageFileUploadInProgress') },
    error: { title: t('errorTitleFileUpload') },
    position,
  });

  const { mutateAsync, isLoading } = useMutation(fileService.uploadFile, {
    ...errors,
  });

  const fileUpload = useCallback(
    (file: File | File[], queryParams: IFileUploadRequestPayload) =>
      mutateAsync({ file, queryParams }),
    [mutateAsync]
  );

  return { fileUpload, isLoading };
};
